import React from 'react';
import ReactDOM from 'react-dom/client';
import { StyleProvider } from '@ant-design/cssinjs';
import 'antd/dist/reset.css'; // 对于 antd 5.x
import App from './App';
import { message } from 'antd'; // 引入 message
// 配置 message
message.config({
    top: 24,       // 消息提示距离顶部的距离（像素）
    duration: 2,   // 消息显示的持续时间（秒）
    maxCount: 3,   // 同时显示的最大消息数量
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>
        <StyleProvider>
            <App />
        </StyleProvider>
    // </React.StrictMode>
);
